
import React, { useState, Fragment, useEffect } from "react";
import './../../../../assets/voucher.css';
import ReactHtmlParser from "react-html-parser";
import styled from "styled-components";
import aiva_logo from "./../../../../assets/aiva_logo.png";
import { Row, Input, Button, Card, CardBody, Modal, ModalBody, ModalFooter, ModalHeader, CustomInput, Label } from "reactstrap";
import { Colxx } from "../../../../components/common/CustomBootstrap";
import { AxiosAPI, getGroupID } from "../../../../helpers/AxiosAPI";
import { connect } from "react-redux";
import { API_Order_Voucher_Notes, gAPI_Orders_Voucher } from "../../../../constants/APIs";
import moment from "moment";
import queryString from 'query-string';
const HighlighDiv = styled.div` 
    position: relative;
    z-index: 1;
    background: #FFFFFF;        
    box-shadow: 0 0 20px 0 rgb(223, 207, 146), 0 5px 5px 0 rgb(223, 207, 146);
    border-radius: 25px;
    margin: 1%;
    padding: 2%;
    
    `;

function View({ match, propertyId, user }) {
    const BMB_ORDER_VOUCHER_URL = process.env.REACT_APP_BFF_API + "/api/orders";
    const [searchCode, setSearchCode] = useState('');
    const [noteList, setNoteList] = useState([]);
    const [voucherData, setVoucherData] = useState();
    const [error, setError] = useState('');
    const [show, setShow] = useState(false);
    const [option, setOption] = useState("");
    const [slides, setslides] = useState([]);
    const [imgs, setimgs] = useState([]);
    const [botsettings, setBotSettings] = useState(null);
    const [redeemAmount, setRedeemAmount] = useState(0);
    const [redeemType, setRedeemType] = useState('');
    const [updateModal, setUpdateModal] = useState(false);
    const [showError, setShowError] = useState(false);
    const [propertyInvalid,setPropertyInvalid]=useState(false);
    //const [isLoaded,setIsLoaded]=useState(true);
    let options = [];
    useEffect(() => {
       // if(isLoaded){
        const data = match.params;
        if (data !== undefined && data !== null && data.code !== undefined && data.code !== null && data.code != '') {
            setSearchCode(data.code);
            handleSubmit(data.code);
        }
  //  }
    }, [propertyId]);
    const handleChange = () => {
        if (voucherData.isCard != undefined && voucherData.isCard == true) {
            if (redeemType === 0) {
                console.log(redeemAmount);
                handleCardRedeem('0', redeemAmount);
            } else {
                handleCardRedeem('0', redeemAmount);
            }
        } else {
            handleCardRedeem('0', voucherData.discountedPrice);
        }
        setUpdateModal(false);
    }
    const handleRedeem = (status, value) => {
        let date = moment();
        let redeemdate = date.format('YYYY-MM-DD HH:mm:ss');
        AxiosAPI({
            method: 'PUT',
            url: `${gAPI_Orders_Voucher}/voucher/redeem?amount=${0}&id=00000000-0000-0000-0000-000000000000&voucherNumber=${searchCode}&status=${status}&redeemDate=${redeemdate}`,
        })
            .then(res => {
                let name = user ? user.profile.name : "";
                AddNote(name + " changes order status available to " + 'Redeem');
                setUpdateModal(!updateModal);
                handleReload();
            })
            .catch(err => null);

        // GetNotes();
    };

    const handleCardRedeem = (status, amount) => {
        if (voucherData.balance >= redeemAmount) {
            let date = moment();
            let redeemdate = date.format('YYYY-MM-DD HH:mm:ss');
            if (((voucherData.balance - redeemAmount) === 0
                || redeemType == '0'))
                status = '0';
            AxiosAPI({
                method: 'PUT',
                url: `${gAPI_Orders_Voucher}/voucher/redeem?amount=${amount}&id=00000000-0000-0000-0000-000000000000&voucherNumber=${searchCode}&status=${status}&redeemDate=${redeemdate}`,
            })
                .then(res => {
                    let name = user ? user.profile.name : "";
                    if (redeemAmount - voucherData.balance === 0)
                        AddNote(name + " changes order status " + voucherData.redeem + " to " + 'Redeem');
                    if (voucherData.isCard === true) {
                        if (redeemType === 0)
                            AddNote('User ' + name + ' redeemed the Gift Card in full for $' + voucherData.balance + ', remaining balance 0.');
                        else
                            AddNote('User ' + name + ' partially redeemed the Gift Card in full for $' + voucherData.balance + ', remaining balance $' + (voucherData.balance - redeemAmount) + '.');
                    }
                    handleReload();
                })
                .catch(err => null);
        }
    };
    const handleSubmit = (searchCode) => {
        AxiosAPI({
            url: `${BMB_ORDER_VOUCHER_URL}/voucher/info?search=${searchCode}&groupId=${getGroupID()}&propertyId=${propertyId}`,
            method: "GET",
        }).then((json) => {
            if (json.data.length > 0) {
                if (json.data[0].propertyId === propertyId) {
                    if (json.data[0].redeem != 2)
                        setShow(true);
                    setVoucherData(json.data[0]);

                    AxiosAPI({
                        url: `${API_Order_Voucher_Notes}?voucherNumber=${searchCode}`,
                        method: "GET",
                    })
                        .then((res) => {
                            setNoteList(res.data.notesList);
                        });
                } else
                    setPropertyInvalid(true);
            } else {
                setShowError(true);
            }
        });
    }
    const handleReload = () => {
        AxiosAPI({
            url: `${BMB_ORDER_VOUCHER_URL}/voucher/info?search=${searchCode}&groupId=${getGroupID()}&propertyId=${propertyId}`,
            method: "GET",
        }).then((json) => {
            if (json.data.length > 0) {
                setVoucherData(json.data[0]);

                AxiosAPI({
                    url: `${API_Order_Voucher_Notes}?voucherNumber=${searchCode}`,
                    method: "GET",
                })
                    .then((res) => {
                        setNoteList(res.data.notesList);
                    });
            }
        });
    }
    const AddNote = (note) => {
        AxiosAPI({
            method: 'post',
            url: `${API_Order_Voucher_Notes}`,
            data: { 'VoucherNumber': searchCode, 'Notes': [{ 'Note': note, 'CreatedDate': moment().format('YYYY-MM-DD') }] }
        })
            .then(res => {
                // setNoteModal(false);
                handleReload();
            })
            .catch(err => null);

    };
    return (
        <Fragment>
            <Row className="mt-3 mb-2">
                <Card style={{ width: '100%', borderRadius: '1.25rem', margin: '1rem' }}>
                    <CardBody>
                        <Colxx md="12" className="mt-2 mb-3">
                            <h3 className="mb-2"><b>Search for a gift card</b></h3>
                        </Colxx>
                        <Row className="ml-1">
                            <Colxx md={5} className="mb-3">
                                <Input
                                    style={{ height: '2.5rem' }}
                                    type="text"
                                    value={searchCode}
                                    name="serch"
                                    placeholder="aivaVXFTHD887"
                                    onChange={(event) =>
                                        setSearchCode(
                                            event.target.value
                                        )
                                    }
                                />
                            </Colxx>
                            <Colxx md={4} className="mb-3 text-end">
                                <Button color="primary" onClick={() => handleSubmit(searchCode)}> Search</Button>
                            </Colxx>
                        </Row>

                    </CardBody>
                </Card>
            </Row>

            {voucherData != undefined && <Row className="mt-3 mb-2">
                <Card style={{ width: '100%', borderRadius: '1.25rem', margin: '1rem' }}>
                    <CardBody>
                        <Row className="my-3 col-md-12">
                            <div className='col-md-3 mb-1'>
                                <h4><b>Balance</b></h4>

                                <p className="mt-1"> ${voucherData.balance} </p>
                            </div>
                            <div className='col-md-3 mb-1'>
                                <h4><b>Status</b></h4>
                                <div style={{ color: `${voucherData.redeem == '2' ? '#2F9A63' : 'rgb(221, 24, 24)'}` }}>
                                    <span className=''>{voucherData.redeem == 2 && 'Available'} {voucherData.redeem == 1 && 'Void'} {voucherData.redeem == 0 && 'Redeemed'} {voucherData.redeem == 3 && 'Refunded'}</span>
                                </div>
                            </div>
                            <div className='col-md-3 mb-1'>
                                <h4><b>Item Purchased</b></h4>
                                <p className="mt-1"> {voucherData.name} </p>
                            </div>
                            <div className='col-md-3 mb-1'>
                                <h4><b>Recipient</b></h4>
                                <p className="mt-1"> {voucherData.email} </p>
                            </div>
                        </Row>

                        {voucherData.isCard === true && voucherData.redeem == 2 &&
                            <Row className="mb-3">
                                <div className='col-md-6 mb-1'>
                                    <Button
                                        color="primary"
                                        outline
                                        size="lg"
                                        onClick={() => {
                                            setRedeemType(0);
                                            setUpdateModal(!updateModal);
                                        }}
                                        style={{ width: '100%', borderRadius: '6px' }}
                                    >
                                        Fully Redeem
                                    </Button>
                                </div>
                                <div className='col-md-6 mb-1'>
                                    <Button
                                        color="primary"
                                        outline
                                        size="lg"
                                        onClick={() => {
                                            setRedeemType(1);
                                            setUpdateModal(!updateModal);
                                        }}
                                        style={{ width: '100%', borderRadius: '6px' }}
                                    >
                                        Partially Redeem
                                    </Button>
                                </div>
                            </Row>}

                        {voucherData.isCard === false && voucherData.redeem == 2 &&

                            <Row className="mb-3">
                                <div className='col-md-12 mb-1'>
                                    <Button
                                        color="primary"
                                        outline
                                        size="lg"
                                        onClick={() => {
                                            setRedeemType(0);
                                            setUpdateModal(!updateModal);
                                        }}
                                        style={{ width: '100%', borderRadius: '6px' }}
                                    >
                                        Redeem
                                    </Button>
                                </div>
                            </Row>}

                        <Row className="mb-3">
                            <div className='col-md-12 mb-2'>
                                <h4><b>Instructions</b></h4>
                            </div>
                            <div className='col-md-12 mb-2 ml-1'>
                                <Card className="mb-2" style={{ width: '100%', borderRadius: '1.25rem' }}>
                                    <CardBody>
                                        {ReactHtmlParser(voucherData.instructions)}
                                    </CardBody>
                                </Card>
                            </div>
                        </Row>
                        <Row className="mb-3">
                            <div className='col-md-12 mb-2'>
                                <h4><b>History</b></h4>
                            </div>
                            <div className='col-md-12 mb-2 ml-1'>
                                <ul className="list-group">
                                    {noteList != null && noteList.length > 0 && noteList.map((m) =>
                                        <Card className="mb-3" style={{ width: '100%', borderRadius: '1.25rem' }}>
                                            <CardBody>
                                                <li style={{ border: 'none' }} className="list-group-item d-flex justify-content-between align-items-center">
                                                    {m.note}
                                                    {window.innerWidth < 700 ? <span style={{ position: 'absolute', right: '0px', bottom: '-5px' }} className="badge badge-primary badge-pill">{m.timegap}</span> :
                                                        <span className="badge badge-primary badge-pill">{m.timegap}</span>}

                                                </li>
                                            </CardBody>
                                        </Card>
                                    )}
                                </ul>

                            </div>
                        </Row>
                    </CardBody>
                </Card>
            </Row>}

            <Modal
                isOpen={updateModal}
                toggle={() => setUpdateModal(false)}
                size="lg"
                style={{ maxWidth: `${window.innerWidth < 700 ? '100%' : '40%'}` }}
            >
                <ModalHeader toggle={() => setUpdateModal(false)}><h3>Voucher Status</h3></ModalHeader>
                <ModalBody>
                    {voucherData != undefined && voucherData.isCard === true ?
                        <Fragment>
                            <Row className="mb-2">
                                <div className='col-md-12'>
                                    <b>Balance: $<span className=''>{voucherData != undefined && voucherData.balance}</span></b>
                                </div>
                            </Row>
                            {redeemType !== '' && <Row className="my-3">
                                <div className='d-flex ml-3'>
                                    <b> Balance to Redeem</b>:{redeemType == 0 ? <span className='ml-1'>${voucherData.balance}</span> :
                                        <Fragment> {voucherData.balance > 0 ?<Fragment>
                                            <Input className="ml-2" type="number" max={voucherData != undefined && voucherData.balance} value={redeemAmount} style={{ width: '30%' }}
                                                onChange={(e) =>{
                                                    if(voucherData.balance - e.target.value >= 0) {
                                                        setRedeemAmount(e.target.value);
                                                        setError('');
                                                    }else{
                                                        setError('Amount should be equal or less than the Balance');
                                                    }

                                                }} ></Input> {error !== '' && <span className='ml-2' style={{ color: 'red' }}>Amount should be equal or less than the Balance</span>}</Fragment>
                                            : <span className='ml-1'>$0</span>}
                                        </Fragment>}
                                </div>

                                <div className='col-md-12  my-3'>
                                    <b>Remaining Balance</b>:
                                    <span className='ml-2'>${voucherData != undefined && (voucherData.balance - redeemAmount)}</span></div>
                            </Row>}
                        </Fragment>
                        : <Row className="m-2">
                            <h6>Are you sure you want to redeem?</h6>
                        </Row>}
                </ModalBody>
                <ModalFooter>
                    <Button color="primary" onClick={() => {
                        if (voucherData !== undefined && voucherData.isCard == true)
                            handleChange();
                        else
                            handleRedeem('0');
                    }}>
                        Redeem
                    </Button>
                    <Button onClick={() => setUpdateModal(false)}>
                        Cancel
                    </Button>
                </ModalFooter>
            </Modal>

            <Modal
                isOpen={show}
                toggle={() => setShow(false)}
                size="lg"
                style={{ maxWidth: '40%' }}
            >
                <ModalHeader toggle={() => setUpdateModal(false)}><h3>Voucher Status</h3></ModalHeader>
                <ModalBody>

                    <Row className="m-2">
                        <h5>{(voucherData !== undefined && voucherData.isCard === false) ? 'Voucher is already redeemed' : 'E-Gift is already redeemed'}</h5>
                    </Row>

                </ModalBody>
                <ModalFooter>

                    <Button onClick={() => setShow(false)}>
                        Cancel
                    </Button>
                </ModalFooter>
            </Modal>


            <Modal
                isOpen={showError}
                toggle={() => setShowError(false)}
                size="lg"
                style={{ maxWidth: '40%' }}
            >
                <ModalHeader toggle={() => setShowError(false)}><h3><b>aiva</b></h3></ModalHeader>
                <ModalBody>
                    <Row className="m-2">
                        <h5>The Voucher/Gift Card Code is invalid.</h5>
                    </Row>
                </ModalBody>
                <ModalFooter>

                    <Button onClick={() => setShowError(false)}>
                        Close
                    </Button>
                </ModalFooter>
            </Modal>

            <Modal
                isOpen={propertyInvalid}
                toggle={() => setPropertyInvalid(!propertyInvalid)}
                size="lg"
                style={{ maxWidth: '40%' }}
            >
                <ModalHeader toggle={() =>  setPropertyInvalid(!propertyInvalid)}><h3><b>aiva</b></h3></ModalHeader>
                <ModalBody>
                    <Row className="m-2">
                        <h5>You do not have access to process this voucher, please check with your business administrator.</h5>
                    </Row>
                </ModalBody>
                <ModalFooter>

                    <Button onClick={() =>  setPropertyInvalid(!propertyInvalid)}>
                        Close
                    </Button>
                </ModalFooter>
            </Modal>



        </Fragment >
    );
}


const mapStateToProps = ({ settings, oidc }) => {
    const { propertyId, locale } = settings;
    return {
        propertyId, locale, user: oidc.user,
    };
};

export default (connect(mapStateToProps, {})(View));